<script>
import {mapState} from 'vuex';

export default {
    filters: {
        noReferrence: (ref) => {
            return (ref) || 'n/a'
        }
    },
    props: {
        customerName: {
            type: String,
            required: true
        },
        supplierRef: {
            type: [Number, String],
            default: null
        },
        bookingRef: {
            type: [Number, String],
            required: true
        },
        bookingDate: {
            type: String,
            required: true
        },
        bookingStatus: {
            type: String,
            required: true,
            default: 'unknown'
        },
        arrivalDate: {
            type: String,
            required: true
        },
        departureDate: {
            type: String,
            required: true
        },
        domain: {
            type: String,
            required: true
        },
        accommodation: {
            type: String,
            required: true
        },
        site: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            toggled: false
        }
    },
    computed: {
        ...mapState({
            user: state => state.auth.user,
        })
    },
}
</script>
<template>
    <div :class="{'booking-item__control--toggled': toggled}" class="booking-item">
        <div class="booking-item__header">
            <div class="booking-item__label">
                {{ supplierRef | noReferrence }}
            </div>
            <div class="booking-item__control" @click="toggled = !toggled">
                <i class="fa fa-fw fa-info"/>
            </div>
        </div>
        <transition name="booking-item__content-animation">
            <div v-if="toggled" class="booking-item__content">
                <div class="booking-item__props">
                    <div class="booking-item__prop">
                        <div class="booking-item__prop-key">
                            {{ $t('bookingItem.bookingRef') }}
                        </div>
                        <div class="booking-item__prop-value">
                            {{ bookingRef | convertStringToNumber }}
                        </div>
                    </div>
                    <div class="booking-item__prop">
                        <div class="booking-item__prop-key">
                            {{ $t('bookingItem.customerName') }}
                        </div>
                        <div class="booking-item__prop-value">
                            {{ customerName }}
                        </div>
                    </div>
                    <div class="booking-item__prop">
                        <div class="booking-item__prop-key">
                            {{ $t('bookingItem.bookingDate') }}
                        </div>
                        <div class="booking-item__prop-value">
                            {{ bookingDate | moment("DD/MM/YYYY") }}
                        </div>
                    </div>
                    <div class="booking-item__prop">
                        <div class="booking-item__prop-key">
                            {{ $t('bookingItem.status') }}
                        </div>
                        <div class="booking-item__prop-value">
                            {{ $t('bookingFilters.status.types.' + bookingStatus) }}
                        </div>
                    </div>
                    <div class="booking-item__prop">
                        <div class="booking-item__prop-key">
                            {{ $t('bookingItem.departureDate') }}
                        </div>
                        <div class="booking-item__prop-value">
                            {{ departureDate | moment("DD/MM/YYYY") }}
                        </div>
                    </div>
                    <div class="booking-item__prop">
                        <div class="booking-item__prop-key">
                            {{ $t('bookingItem.arrivalDate') }}
                        </div>
                        <div class="booking-item__prop-value">
                            {{ arrivalDate | moment("DD/MM/YYYY") }}
                        </div>
                    </div>
                    <div class="booking-item__prop">
                        <div class="booking-item__prop-key">
                            {{ $t('bookingItem.domain') }}
                        </div>
                        <div class="booking-item__prop-value">
                            {{ domain }}
                        </div>
                    </div>
                    <div class="booking-item__prop">
                        <div class="booking-item__prop-key">
                            {{ $t('bookingItem.accommodation') }}
                        </div>
                        <div class="booking-item__prop-value">
                            {{ accommodation }}
                        </div>
                    </div>
                    <div class="booking-item__prop">
                        <div class="booking-item__prop-key">
                            {{ $t('bookingItem.site') }}
                        </div>
                        <div class="booking-item__prop-value">
                            {{ site }}
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/BookingItem/BookingItem.vue